import { SkeletonBigField, SkeletonButton, SkeletonSmallField } from './SkeletonElements';
import { Modal } from '..';
import FormContent from '../SettingsLayout/FormComponents/FormContent';

function SkeletonModal() {
  return (
    <>
      <Modal.Content>
        <SkeletonBigField />
        <SkeletonButton />
      </Modal.Content>
      <Modal.Content>
        <FormContent>
          <SkeletonSmallField />
          <SkeletonSmallField />
          <SkeletonSmallField />
          <SkeletonSmallField />
          <SkeletonSmallField />
          <SkeletonSmallField />
          <SkeletonSmallField />
        </FormContent>
      </Modal.Content>
      <Modal.Footer justify='flex-end'>
        <SkeletonButton />
        <SkeletonButton />
      </Modal.Footer>
    </>
  );
}

export default SkeletonModal;
